function parseRoles(roles?: string | null): string[] {
  if (!roles) return []
  return roles
    .toLowerCase()
    .split(',')
    .map((role) => role.trim())
    .filter((role) => role.length > 0)
}

export function isWorkspaceMemberViewer(member?: { roles?: string | null }) {
  const roles = parseRoles(member?.roles)
  const allowedRoles = ['admin', 'editor', 'member', 'owner']
  return !roles.some((role) => allowedRoles.includes(role))
}

export function isWorkspaceMemberAdmin(member?: { roles?: string | null }) {
  const roles = parseRoles(member?.roles)
  return roles.includes('admin') || roles.includes('owner')
}
